__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/53f646807617c7217a99e047b60e0f239d33cdb7/_next/";